module.exports = __webpack_public_path__ + "img/3-2.3fba7fc2.png";